import { Banner, Row } from 'darrius';

import { Testimonial } from '../../molecules';

interface ITestimonialsProps {
  testimonialsContent?: {
    title: string;
    text: string;
    testimonials: any[];
  };
}

export const Testimonials = (props: ITestimonialsProps) => {
  const { testimonialsContent } = props;

  if (!testimonialsContent) {
    return null;
  }

  const { title, text, testimonials } = testimonialsContent;

  return (
    <Banner as="section" size="2" title={title} text={text}>
      <Row className="space-top list">
        {testimonials.map((testimonialData) => (
          <Testimonial
            key={testimonialData.title}
            testimonialContent={testimonialData}
          />
        ))}
      </Row>
    </Banner>
  );
};

export default Testimonials;
